/* tslint:disable */
/* eslint-disable */
export enum EventType {
  SelfCheckinRegistrationCompleted = 'self_checkin_registration_completed',
  SelfCheckinCheckinFinished = 'self_checkin_checkin_finished',
  SelfCheckinDriverWaiting = 'self_checkin_driver_waiting',
  CheckoutFinished = 'checkout_finished',
  CheckinFinished = 'checkin_finished',
  ReferenceNumberUpdated = 'reference_number_updated'
}
